export default __webpack_public_path__ + "static/media/image-41.8dabf947.png";